import {Component, ElementRef, HostBinding, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ImageSubType} from '@api/models/image/image-type';
import {AdCampaignService} from '../../services/ad-campaign.service';
import {UrlService} from '@utils/services/url/url.service';
import {ISponsor} from '@api/models/sponsor/sponsor';
import {EntityType} from '@lib/models/entity/entity-type';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';

@Component({
  selector: 'lib-ad-sponsor-banner',
  templateUrl: './ad-sponsor-banner.component.html',
  styleUrls: ['./ad-sponsor-banner.component.scss']
})
export class AdSponsorBannerComponent implements OnInit, OnDestroy {

  @Input() public sponsors: ISponsor[];
  @Input() public useDomain = false;
  @Input() public lightHeading = false;
  @Input() public insetHeader = false;
  @Input() public hideHeader = false;
  @Input() public alwaysShow = false;
  @Input() public colorScheme = ColorScheme.Dark;
  @HostBinding('class.simple') @Input() public simple = false;
  @Input() public headerText = 'Das Spiel wird präsentiert von';
  public subtype = ImageSubType.IMAGE;
  public scrolledEnd = false;
  public startButtonLeft = '0px';
  private adContainer: ElementRef;
  @Input() private entityId: string;
  @Input() private entityType: EntityType;
  @ViewChild('adContainer') private set setAdContainer(container: ElementRef) {
    if (container) {
      this.setStartButtonLeft(container);
      this.adContainer = container;
    }
  }

  constructor( public adCampaignService: AdCampaignService,
               @Inject(PLATFORM_ID) private platformId ) { }

  public async ngOnInit(): Promise<void> {
    if (this.useDomain && !UrlService.domain?.length) {
      return;
    }
    await this.adCampaignService.getAdCampaignForEntity(this.entityId, this.entityType, UrlService.domain);
    if (this.adCampaignService.campaign?.length > 0 && this.adCampaignService.showCampaign) {
      this.sponsors = null;
    }
  }

  public ngOnDestroy(): void {
    this.adCampaignService.reset();
  }

  private setStartButtonLeft(container: ElementRef): void {
    if (container?.nativeElement) {
      const elem = container.nativeElement;
      this.startButtonLeft = (elem.scrollWidth - elem.offsetWidth) + 'px';
    }
  }

  public toStart(): void {
    this.adContainer.nativeElement.scrollTo(0, 0);
    this.scrolledEnd = false;
  }

  public toEnd(): void {
    this.adContainer.nativeElement.scrollTo(2000, 0);
    this.scrolledEnd = true;
  }
}
